import styled from '@emotion/styled';

export const ProductSpecTitle = styled.div<{ padding: string }>`
  ${({ padding }) => padding && `padding : ${padding}px 0px;`};

  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 4px; /* &nbsp; 대신 간격 */
  align-items: flex-start;
`;
